<template>
  <i class="icon_wrap"></i>
</template>

<script>
export default {
  name: 'Dark'
};
</script>

<style lang="stylus" scoped>
.icon_wrap
  display inline-block
  width 24px
  height 24px
  background-size 24px 24px
  background-repeat no-repeat
  background-position center
  background-image url('./images/mine_collect_icon_sel_select.png')
  background-image image-set(url('./images/mine_collect_icon_sel_select.png') 1x, url('./images/mine_collect_icon_sel_select@2x.png') 2x)
</style>
